'use client';
import { useRemoteMedia } from './useRemoteMedia';

export const useRemoteAudio = (props: {
  peerId: string;
  onClose?: (reason?: {
    code: number;
    tag: string;
    message: string;
  }) => void;
  onPlayable?: (data: {
    track: MediaStreamTrack;
    stream: MediaStream;
    label: 'audio';
  }) => void;
  onPaused?: () => void;
  onResumed?: () => void;
}) => {
  const { state, track, stream } = useRemoteMedia({
    label: 'audio',
    peerId: props.peerId,
    onClose: props.onClose,
    onPlayable: (data) => {
      props.onPlayable?.({
        label: 'audio',
        track: data.track,
        stream: data.stream,
      });
    },
    onPaused: props?.onPaused,
  });

  const isAudioOn = state === 'playable';

  return {
    state,
    isAudioOn,
    track,
    stream,
  };
};
